(function () {
  'use strict';

  var SELECTOR = '[data-canicule-marketplace-pulse]';
  var SOLD_DURATION_MS = 3200;
  var REVIEW_DURATION_MS = 2400;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text == null ? '' : String(text);
    return div.innerHTML;
  }

  function formatFr(n) {
    return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '\u202f');
  }

  function formatRating(n) {
    return String(n).replace('.', ',');
  }

  function easeInOutQuart(t) {
    return t < 0.5 ? 8 * t * t * t * t : 1 - Math.pow(-2 * t + 2, 4) / 2;
  }

  function animateValue(el, target, duration, easingFn) {
    var start = performance.now();
    function frame(now) {
      var t = Math.min(1, (now - start) / duration);
      var eased = easingFn(t);
      el.textContent = formatFr(target * eased);
      if (t < 1) requestAnimationFrame(frame);
      else el.textContent = formatFr(target);
    }
    requestAnimationFrame(frame);
  }

  function renderStars(rating) {
    var html = '';
    var i;
    for (i = 1; i <= 5; i += 1) {
      var cls = 'canicule-marketplace-pulse__star';
      if (rating >= i - 0.25) cls += ' is-full';
      else if (rating >= i - 0.75) cls += ' is-half';
      html += '<span class="' + cls + '" aria-hidden="true">★</span>';
    }
    return html;
  }

  function productUrl(handle) {
    if (!handle) return '';
    return '/products/' + encodeURIComponent(handle);
  }

  function renderMetric(container, metric, index) {
    var article = document.createElement('article');
    article.className = 'canicule-marketplace-pulse__metric';
    article.setAttribute('role', 'listitem');
    article.style.setProperty('--pulse-delay', index * 0.15 + 's');

    var soldBlock = '';
    if (metric.soldCount) {
      soldBlock =
        '<div class="canicule-marketplace-pulse__sold">' +
        '<p class="canicule-marketplace-pulse__value">' +
        '<span class="canicule-marketplace-pulse__plus">+</span>' +
        '<span class="canicule-marketplace-pulse__number" data-pulse-sold>0</span>' +
        '</p>' +
        '<p class="canicule-marketplace-pulse__suffix">' + escapeHtml(metric.soldLabel || 'commandes documentées') + '</p>' +
        '</div>';
    }

    var reviewBlock =
      '<div class="canicule-marketplace-pulse__reviews">' +
      '<p class="canicule-marketplace-pulse__review-value">' +
      '<span data-pulse-reviews>0</span>' +
      '<span class="canicule-marketplace-pulse__review-plus">+</span>' +
      '</p>' +
      '<p class="canicule-marketplace-pulse__review-label">' + escapeHtml(metric.reviewLabel || 'avis') + '</p>' +
      '</div>';

    var productLink = metric.productHandle
      ? '<p class="canicule-marketplace-pulse__product-link"><a href="' + escapeHtml(productUrl(metric.productHandle)) + '">Voir le modèle Canicule</a></p>'
      : '';

    var sourceLink = metric.sourceUrl
      ? '<p class="canicule-marketplace-pulse__source"><a href="' + escapeHtml(metric.sourceUrl) + '" target="_blank" rel="noopener noreferrer">Source ' + escapeHtml(metric.platform || 'marketplace') + '</a></p>'
      : '';

    article.innerHTML =
      '<div class="canicule-marketplace-pulse__glow" aria-hidden="true"></div>' +
      '<div class="canicule-marketplace-pulse__rating" aria-label="Note ' + formatRating(metric.rating) + ' sur 5, marketplace hors Canicule">' +
      '<span class="canicule-marketplace-pulse__stars">' + renderStars(metric.rating) + '</span>' +
      '<span class="canicule-marketplace-pulse__rating-num">' + formatRating(metric.rating) + '</span>' +
      '</div>' +
      soldBlock +
      reviewBlock +
      '<p class="canicule-marketplace-pulse__label">' + escapeHtml(metric.label) + '</p>' +
      '<p class="canicule-marketplace-pulse__platform">' + escapeHtml(metric.platform) + '</p>' +
      '<p class="canicule-marketplace-pulse__detail">' + escapeHtml(metric.detail) + '</p>' +
      productLink +
      sourceLink;

    container.appendChild(article);

    return {
      soldEl: article.querySelector('[data-pulse-sold]'),
      soldValue: metric.soldCount,
      reviewEl: article.querySelector('[data-pulse-reviews]'),
      reviewValue: metric.reviewCount
    };
  }

  function initRoot(root) {
    if (root._caniculePulseInit) return;
    root._caniculePulseInit = true;

    var url = root.dataset.pulseUrl;
    if (!url) return;

    fetch(url)
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (data) {
        if (!data || !data.metrics || !data.metrics.length) return;

        var grid = root.querySelector('[data-pulse-grid]');
        if (!grid) return;

        var disclaimer = root.querySelector('[data-pulse-disclaimer]');
        if (disclaimer && data.meta && data.meta.disclaimer) {
          disclaimer.textContent = data.meta.disclaimer;
        }

        var animItems = [];
        data.metrics.forEach(function (metric, i) {
          animItems.push(renderMetric(grid, metric, i));
        });

        function runAnimation() {
          animItems.forEach(function (item, i) {
            var delay = i * 220;
            window.setTimeout(function () {
              if (prefersReducedMotion()) {
                if (item.soldEl && item.soldValue) item.soldEl.textContent = formatFr(item.soldValue);
                if (item.reviewEl && item.reviewValue) item.reviewEl.textContent = formatFr(item.reviewValue);
                return;
              }
              if (item.soldEl && item.soldValue) {
                animateValue(item.soldEl, item.soldValue, SOLD_DURATION_MS, easeInOutQuart);
              }
              window.setTimeout(function () {
                if (item.reviewEl && item.reviewValue) {
                  animateValue(item.reviewEl, item.reviewValue, REVIEW_DURATION_MS, easeInOutQuart);
                }
              }, item.soldValue ? 350 : 0);
            }, delay);
          });
        }

        if ('IntersectionObserver' in window && !prefersReducedMotion()) {
          var observer = new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;
                observer.disconnect();
                runAnimation();
              });
            },
            { threshold: 0.3 }
          );
          observer.observe(root);
        } else {
          runAnimation();
        }
      })
      .catch(function () {});
  }

  function init(scope) {
    (scope || document).querySelectorAll(SELECTOR).forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
